import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.svg'
import { useSelector } from 'react-redux'

const Footer = () => {
    const lang = useSelector((state) => state.lang.lang)

    return (
        <div className='footer'>
            <div className='first-logo'><img src={logo} alt='' /></div>
            <div className='top'>
                <div className='left'>
                    <div className='first'>
                        <div><Link to={lang === "tr" ? "/about-us" : "/about-us"}>About Us</Link></div>
                        {/* <div className='mt-2'><Link to="#">Services</Link></div> */}
                        <div className='mt-2'><Link to="/libecms">LibeCMS</Link></div>
                        <div className='mt-2'><Link to={lang === "tr" ? "/references" : "/references"}>References</Link></div>
                        {/* <div className='mt-2'><Link to={lang === "tr" ? "/career" : "/career"}>Career</Link></div> */}
                        <div className='mt-2'><Link to={lang === "tr" ? "/contact" : "/contact"}>Contact</Link></div>
                        <div className='mt-2'><Link to={lang === "tr" ? "/partnership" : "/partnership"}>Partnerships</Link></div>
                    </div>
                    <div className='second'>
                        <div><strong>Legal Information</strong></div>
                        <div className='mt-2'><span>Cookie Policy</span></div>
                        <div className='mt-2'><Link to="/KVKK-sozlesmesi.pdf" target='_blank' rel='noopener noreferrer'>KVKK Information Text for Contract Processes of Suppliers and Customers</Link></div>
                        <div className='mt-2'><Link to="/kullanici-sozlesmesi.pdf" target='_blank' rel='noopener noreferrer'>Application Form to Data Controller</Link></div>
                        <div className='mt-2'><span>Privacy Agreement and Usage Rights</span></div>
                        <div className='mt-2'><span>Information Society Services</span></div>
                        <div className='mt-2'><span>Sitemap</span></div>
                    </div>
                </div>
                <div className='right'>
                    <div className='third'>
                        <div className=''><Link to="https://www.linkedin.com/company/liberyus/" target="_blank"  rel="noopener noreferrer">LinkedIn</Link></div>
                        <div className='mt-2'><Link to="https://www.facebook.com/liberyus/" target="_blank"  rel="noopener noreferrer">Facebook</Link></div>
                        <div className='mt-2'><Link to="https://www.instagram.com/liberyus/" target="_blank"  rel="noopener noreferrer">Instagram</Link></div>
                        <div className='mt-2'><Link to="https://www.x.com/liberyus/" target="_blank"  rel="noopener noreferrer">Twitter</Link></div>
                        <div className='mt-2'><Link to="https://www.behance.net">Behance</Link></div>
                    </div>
                    <div className='fourth'>
                        <div>Let’s grab some coffee. ☕️</div>
                        <div className='mt-3'></div>
                        <div className='mt-2'><strong>We are waiting you...</strong></div>
                        <div className='mt-3'></div>
                        <div className='mt-2'><Link to="tel:+90 312 437 0 222">+90 312 437 0 222</Link></div>
                        <div className='mt-3'></div>
                        <div className='mt-2'><a href="mailto:bilgi@liberyus.com" target="_blank"  rel="noopener noreferrer">bilgi@liberyus.com</a></div>
                    </div>
                </div>
            </div>
            <div className='down'>
                <div><img src={logo} alt='' /></div>
                <div><span>© {new Date().getFullYear()} Liberyus IT All Rights Reserved</span></div>
            </div>
        </div>
    )
}

export default Footer
